<template>
    <PageLayout content-class="p-0" :has-page-scroll="true">
        <template #content>
            <div class="col-12 p-3 card align-items-center">
                <FormSection
                    title="Add Referral"
                    :fullHeight="false"
                    class="card-body p-2"
                    v-if="!isLineOfServiceFormRequested"
                >
                    <template #content v-if="!isAddingReferralLoading">
                        <div class="d-flex mx-2 py-2 px-3 pb-2">
                            <div class="form-group col-3 col-md-4 pe-3">
                                <label> Patient </label>
                                <input
                                    type="text"
                                    class="form-control"
                                    v-model="searchPatientTerm"
                                    placeholder="Search by patient name or MRN"
                                />
                            </div>
                            <div class="form-group d-flex pe-4">
                                <button
                                    class="btn btn-primary align-self-end"
                                    @click="search()"
                                    :disabled="!searchPatientTerm || isSearchLoading"
                                >
                                    Search
                                </button>
                            </div>
                            <div class="form-group d-flex align-self-end">
                                <BranchDefaultFilter
                                    :checkAllByDefault="true"
                                    :selected-branches="selectedBranches"
                                    v-on:updateBranches="updateBranches"
                                    :is-referral="true"
                                />
                            </div>
                            <template v-if="showNewReferral">
                                <div class="form-group d-flex ms-auto" v-if="!inquiry">
                                    <button
                                        type="button"
                                        class="btn btn-primary align-self-end dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        New Referral
                                    </button>
                                    <div class="dropdown-menu">
                                        <a
                                            v-if="
                                                (hasInquiryId &&
                                                    inquiryApplication == hospiceApplicationId &&
                                                    checkProductPermission.showNewReferralHospice) ||
                                                (!hasInquiryId &&
                                                    checkProductPermission &&
                                                    agencyApplicationList.includes(hospiceApplicationId))
                                            "
                                            class="dropdown-item"
                                            @click="openLineOfService(hospiceApplicationId)"
                                            >Axxess Hospice</a
                                        >
                                        <a
                                            v-if="
                                                (hasInquiryId &&
                                                    inquiryApplication == palliativeApplicationId &&
                                                    checkProductPermission.showNewReferralHospice) ||
                                                (!hasInquiryId &&
                                                    checkProductPermission &&
                                                    agencyApplicationList.includes(palliativeApplicationId))
                                            "
                                            class="dropdown-item"
                                            @click="openLineOfService(palliativeApplicationId)"
                                            >Axxess Palliative Care</a
                                        >
                                        <a
                                            v-if="
                                                (hasInquiryId &&
                                                    inquiryApplication == homeHealthApplicationId &&
                                                    checkProductPermission.showNewReferralHospice) ||
                                                (!hasInquiryId &&
                                                    checkProductPermission &&
                                                    agencyApplicationList.includes(homeHealthApplicationId))
                                            "
                                            class="dropdown-item"
                                            @click="openLineOfService(homeHealthApplicationId)"
                                            >Axxess Home Health</a
                                        >
                                        <a
                                            v-if="
                                                (hasInquiryId &&
                                                    inquiryApplication == homeCareApplicationId &&
                                                    checkProductPermission.showNewReferralHospice) ||
                                                (!hasInquiryId &&
                                                    checkProductPermission &&
                                                    agencyApplicationList.includes(homeCareApplicationId))
                                            "
                                            class="dropdown-item"
                                            @click="openLineOfService(homeCareApplicationId, false)"
                                            >Axxess Home Care (Medical)</a
                                        >
                                        <a
                                            v-if="
                                                (hasInquiryId &&
                                                    inquiryApplication == homeCareApplicationId &&
                                                    checkProductPermission.showNewReferralHospice) ||
                                                (!hasInquiryId &&
                                                    checkProductPermission &&
                                                    agencyApplicationList.includes(homeCareApplicationId))
                                            "
                                            class="dropdown-item"
                                            @click="openLineOfService(homeCareApplicationId, true)"
                                            >Axxess Home Care (Non-Medical)</a
                                        >
                                    </div>
                                </div>
                                <div class="form-group d-flex ms-auto" v-else>
                                    <button
                                        v-if="currentApplication != homeCareApplicationId"
                                        type="button"
                                        class="btn btn-primary align-self-end"
                                        @click="openLineOfService(currentApplication)"
                                    >
                                        New Patient
                                    </button>
                                    <button
                                        v-else
                                        type="button"
                                        class="btn btn-primary align-self-end dropdown-toggle"
                                        data-bs-toggle="dropdown"
                                        aria-haspopup="true"
                                        aria-expanded="false"
                                    >
                                        New Patient
                                    </button>
                                    <div class="dropdown-menu">
                                        <a
                                            class="dropdown-item"
                                            @click="openLineOfService(homeCareApplicationId, false)"
                                            >Medical</a
                                        >
                                        <a class="dropdown-item" @click="openLineOfService(homeCareApplicationId, true)"
                                            >Non-Medical</a
                                        >
                                    </div>
                                </div>
                            </template>
                        </div>

                        <div v-show="showPatientList" class="mx-2 mt-2">
                            <Pagination
                                ref="patientListPagination"
                                entity="Patients"
                                classes="pagination-footer"
                                :isLoading="isSearchLoading"
                                :pageSize="pageSize"
                                :showPageSizeOptions="true"
                                :pageChanged="pageChangedCallback"
                                v-on:updatePageSizeChanged="updatePageSizeChanged"
                            >
                                <table class="table table-responsive-md border border-gray">
                                    <thead>
                                        <tr class="bg-table-header">
                                            <th class="align-middle">
                                                <SortableTh
                                                    :sort-by="sortBy"
                                                    v-on:sortByUpdated="sortByUpdated"
                                                    :sort-order="sortOrder"
                                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                                    sort-string="patientName"
                                                >
                                                    Patient Information<br />
                                                    MRN
                                                </SortableTh>
                                            </th>
                                            <th class="align-middle">
                                                <SortableTh
                                                    :sort-by="sortBy"
                                                    v-on:sortByUpdated="sortByUpdated"
                                                    :sort-order="sortOrder"
                                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                                    sort-string="primaryAddress"
                                                >
                                                    Address
                                                </SortableTh>
                                            </th>
                                            <th>
                                                <SortableTh
                                                    :sort-by="sortBy"
                                                    v-on:sortByUpdated="sortByUpdated"
                                                    :sort-order="sortOrder"
                                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                                    sort-string="dateOfBirth"
                                                >
                                                    DOB<br />Gender
                                                </SortableTh>
                                            </th>
                                            <th class="align-middle">
                                                <SortableTh
                                                    :sort-by="sortBy"
                                                    v-on:sortByUpdated="sortByUpdated"
                                                    :sort-order="sortOrder"
                                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                                    sort-string="status"
                                                >
                                                    Status
                                                </SortableTh>
                                            </th>
                                            <th>
                                                <SortableTh
                                                    :sort-by="sortBy"
                                                    v-on:sortByUpdated="sortByUpdated"
                                                    :sort-order="sortOrder"
                                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                                    sort-string="startOfCare"
                                                >
                                                    SOC<br />D/C
                                                </SortableTh>
                                            </th>
                                            <th class="align-middle">
                                                <SortableTh
                                                    :sort-by="sortBy"
                                                    v-on:sortByUpdated="sortByUpdated"
                                                    :sort-order="sortOrder"
                                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                                    sort-string="serviceLine"
                                                >
                                                    Service Line
                                                </SortableTh>
                                            </th>
                                            <th class="align-middle">
                                                <SortableTh
                                                    :sort-by="sortBy"
                                                    v-on:sortByUpdated="sortByUpdated"
                                                    :sort-order="sortOrder"
                                                    v-on:sortOrderUpdated="sortOrderUpdated"
                                                    sort-string="branchName"
                                                >
                                                    Branch
                                                </SortableTh>
                                            </th>
                                            <th class="text-end align-middle">Actions</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <!-- EMPTY -->
                                        <tr class="table-empty" v-if="!isSearchLoading && !isSearchError && !hasData">
                                            <td :colspan="columns">
                                                <h3>No Patients Found.</h3>
                                            </td>
                                        </tr>
                                        <!-- ERROR -->
                                        <tr class="table-error" v-if="!isSearchLoading && isSearchError">
                                            <td :colspan="columns">
                                                <ErrorMessageHandler title="Patients" :try-again="search" />
                                            </td>
                                        </tr>
                                        <!-- LOADING -->
                                        <tr v-if="isSearchLoading" v-for="i of 3" class="table-loading" :key="i">
                                            <td v-for="i of columns" :key="i">
                                                <span class="shimmer-loading"></span>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody>
                                        <CreateInterimReferralRow
                                            v-if="!isSearchLoading"
                                            v-for="patient of page?.items"
                                            :key="patient.id"
                                            :agencyServices="agencyService"
                                            :agencyList="agencyApplicationList"
                                            :patient="patient"
                                            :checkProductPermission="checkProductPermission"
                                            :hasDocViewPermission="hasDocViewPermission"
                                            :handleConvertToPending="handleConvertToPending"
                                        />
                                    </tbody>
                                </table>
                            </Pagination>
                        </div>
                    </template>
                </FormSection>
                <FormSection
                    title="New Patient Referral"
                    :fullHeight="false"
                    class="card-body p-2"
                    :applicationId="lineOfService.application"
                    v-else
                >
                    <template #content v-if="!isAddingReferralLoading">
                        <div class="col-12 row g-0 p-3 px-4">
                            <div class="form-group col-3 offset-lg-1 mb-0 me-3">
                                <label for="branch">
                                    Branch
                                    <span class="text-danger ms-1">*</span>
                                </label>
                                <select
                                    class="form-select"
                                    v-model="selectedBranch"
                                    @blur="v$.selectedBranch.id.$touch"
                                >
                                    <option value="null">Select Branch</option>
                                    <template v-if="providerList.length === 1">
                                        <option
                                            v-for="branch of providerList[0].branches"
                                            :value="branch"
                                            :key="branch"
                                        >
                                            {{ branch.name }}
                                        </option>
                                    </template>
                                    <template v-else>
                                        <optgroup
                                            v-for="provider of providerList"
                                            :label="provider.name"
                                            :value="provider"
                                            :key="provider.name"
                                        >
                                            <option
                                                v-for="branch of provider.branches"
                                                :key="branch.name"
                                                :value="branch"
                                            >
                                                {{ branch.name }}
                                            </option>
                                        </optgroup>
                                    </template>
                                </select>
                                <span v-if="isFieldInvalid('branch')" class="field-invalid">Branch is required.</span>
                            </div>
                            <div class="form-group col-3 mb-0 me-3">
                                <label for="firstName">
                                    First Name
                                    <span class="text-danger ms-1">*</span>
                                </label>
                                <input
                                    class="form-control"
                                    name="firstName"
                                    type="text"
                                    placeholder="Enter First Name"
                                    v-model="lineOfService.firstName"
                                    @blur="v$.lineOfService.firstName.$touch"
                                    maxlength="35"
                                    :disabled="isConvertBackToPending"
                                />
                                <span v-if="v$.lineOfService.firstName.$error" class="field-invalid"
                                    >First name is required.</span
                                >
                            </div>
                            <div class="form-group col-3 mb-0 me-3">
                                <label for="lastName">
                                    Last Name
                                    <span class="text-danger ms-1">*</span>
                                </label>
                                <input
                                    class="form-control"
                                    name="lastName"
                                    type="text"
                                    placeholder="Enter Last Name"
                                    v-model="lineOfService.lastName"
                                    @blur="v$.lineOfService.lastName.$touch"
                                    maxlength="50"
                                    :disabled="isConvertBackToPending"
                                />
                                <span v-if="v$.lineOfService.lastName.$error" class="field-invalid"
                                    >Last name is required.</span
                                >
                            </div>
                        </div>
                        <div class="col-12 row g-0 p-2 px-4" v-if="isApplicationHospice">
                            <div class="form-group col-3 offset-lg-1 mb-0 me-3 pb-3">
                                <label for="lineOfService">
                                    Line of Service
                                    <span class="text-danger ms-1">*</span>
                                </label>
                                <select
                                    class="form-select"
                                    v-model="selectedPrimaryLineOfService"
                                    disabled
                                    @blur="v$.selectedPrimaryLineOfService.$touch"
                                >
                                    <option :value="null">Select Line of Service</option>
                                    <option v-for="option of primaryLineOfServiceList" :value="option" :key="option">
                                        {{ lineOfServiceEnumMap.enum[option] }}
                                    </option>
                                </select>
                                <span v-if="isFieldInvalid('selectedPrimaryLineOfService')" class="field-invalid"
                                    >Line of service is required.</span
                                >
                            </div>
                        </div>
                        <div
                            class="p-5 d-flex flex-column items-center text-center text-primary"
                            v-if="isAddingReferralLoading"
                        >
                            <div>
                                <i class="far fa-save fa-7x me-2 animated slow flash infinite"></i>
                            </div>
                            <div class="big-text mt-1">
                                <b>Save Referral In Progress...</b>
                            </div>
                        </div>
                    </template>
                </FormSection>
            </div>
            <div class="col-12 text-center pb-2 mt-2">
                <template v-if="isLineOfServiceFormRequested && !isAddingReferralLoading">
                    <button class="btn btn-primary me-2" @click="addReferralForSelectedPatient()">Add Referral</button>
                    <button class="btn btn-outline-primary" @click="closeLineOfService()">Cancel</button>
                </template>
                <button
                    class="btn btn-outline-primary"
                    @click="cancel()"
                    v-if="!isLineOfServiceFormRequested && !isAddingReferralLoading"
                >
                    Cancel
                </button>
            </div>
        </template>
    </PageLayout>
</template>

<style src="./CreateInterimReferral.scss"></style>

<script lang="ts" src="./CreateInterimReferral.ts"></script>
